import { render } from "./FirstView009.vue?vue&type=template&id=42b5b831&scoped=true"
const script = {}

import "./FirstView009.vue?vue&type=style&index=0&id=42b5b831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b5b831"]])

export default __exports__